import React from 'react';
import Typography from '@material-ui/core/Typography';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  onlyBold: {
    fontWeight: 'bold',
    fontSize: 18,
    textAlign: 'justify',
    marginVertical: 10,
  },
}));

function Topic(props) {
  const classes = useStyles();

  return <Typography className={classes.onlyBold}>{props.text}</Typography>;
}

export default Topic;
